import * as amplitude from '@amplitude/analytics-browser';

export const initAmplitude = () => {
  console.log(process.env, 'env');
  if (process.env.REACT_APP_CUSTOM_NODE_ENV === 'production') amplitude.init('998cb64a73f500d6ac4f103f782e49bf');
  amplitude.track('app_open');
};

export const amplitudeInstance = amplitude;
